import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { NodeValueField } from "@/components/doc/right-sidebar/active-node-style/fields/NodeValueField";
import { UnitTypeSelector } from "@/components/doc/right-sidebar/active-node-style/fields/UnitTypeSelector";

import type { NumberNodeModel } from "@/models/nodes/NumberNodeModel";

type Props = {
  node: NumberNodeModel;
};

export const NumberValueField = observer(function NumberValueField({ node }: Props) {
  const t = useTranslations("sidebar.activeNode");
  const { doc } = node;

  const handleValueChange = (value: string) => {
    doc.transact(() => {
      node.value = value;
    }, "NumberValueField:valueChange");
  };

  return (
    <NodeValueField
      id={`value-${node.id}`}
      value={node.value}
      name={t("fields.value")}
      labelProps={{
        label: t("fields.value"),
      }}
      className="shadow-none dark:shadow-none"
      onValueChange={handleValueChange}
      validate={(value) => node.validateValue(value)}
      action={<UnitTypeSelector node={node} />}
    />
  );
});
